export default __webpack_public_path__ + "static/media/Balls.8a65fa51.png";